// Watch out! Keep this updated with the database!
export enum Permissions {
  see_controller_info = 'see_controller_info',
  see_inverter_info = 'see_inverter_info',
  see_energy_meter_info = 'see_energy_meter_info',
  see_energy_meter_graph = 'see_energy_meter_graph',
  see_energy_meter_knobs = 'see_energy_meter_knobs',
  see_io_info = 'see_io_info',
  see_ems_info = 'see_ems_info',
  see_bms_info = 'see_bms_info',
  see_io_addon_normal = 'see_io_addon_normal',
  see_io_addon_gen2 = 'see_io_addon_gen2',
  see_io_addon_analog = 'see_io_addon_analog',
  see_history_info = 'see_history_info',
  do_download_history = 'do_download_history',
  see_device_type = 'see_device_type',
  see_main_fw_version = 'see_main_fw_version',
  see_io_fw_version = 'see_io_fw_version',
  see_device_client_version = 'see_device_client_version',
  see_board_voltage = 'see_board_voltage',
  see_board_temperature = 'see_board_temperature',
  see_io_com_error = 'see_io_com_error',
  see_activation_info = 'see_activation_info',
  do_inverter_switch = 'do_inverter_switch',
  do_saving_voltage_history = 'do_saving_voltage_history',
  do_crud_users = 'do_crud_users',
  see_users = 'see_users',
  do_crud_permissions = 'do_crud_permissions',
  see_permissions = 'see_permissions',
  see_box_options = 'see_box_options',
  do_box_activations = 'do_box_activations',
}
